import * as React from 'react';
import styles from './index.less';
import { withRouter } from 'umi';
import { connect } from 'dva';
import {
  ConnectState,
  CollectionManagerState,
  CollectionCreatorPageModelState,
} from '@/models/connect';
import { RouteComponentProps } from 'react-router/index';
import { Dispatch } from 'redux';
import * as AHooks from 'ahooks';
import useUrlState from '@ahooksjs/use-url-state';
import FComponentsLib from '@freelog/components-lib';
import { Space, Pagination, Modal } from 'antd';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import {
  ChangeAction,
  Version_OnMount_Page_Action,
  Version_OnUnmount_Page_Action,
  Sider_OnChange_Page_Action,
  Sider_OnMount_Page_Action,
  Version_Fetch_CollectionItems_Action,
  Version_SaveDraft_Action,
  Version_SaveDate_Action,
} from '@/models/collectionManager';
// import fResourcePropertyEditor from '@/components/fResourcePropertyEditor';
// import FResourceProperties from '@/components/FResourceProperties';
import fResourceOptionEditor from '@/components/fResourceOptionEditor';
import FResourceOptions from '@/components/FResourceOptions';
import FBraftEditor from '@/components/FBraftEditor';
import BraftEditor, { EditorState } from 'braft-editor';
import FViewportCards_Resource from '@/components/FAntvG6/FViewportCards_Resource';
import FMicroAPP_Authorization from '@/components/FMicroAPP_Authorization';
import FSkeletonNode from '@/components/FSkeletonNode';
import FHtmlReactParser from '@/components/FHtmlReactParser';
import CollectionSetting from '@/pages/resource/collectionCreator/Step2/CollectionSetting';
import FTooltip from '@/components/FTooltip';
import FLoadingTip from '@/components/FLoadingTip';
import fMessage from '@/components/fMessage';
import ChangeLogDrawer from '@/pages/resource/collectionSidebar/versionInfo/$id/ChangeLogDrawer';
import fSelectResourcesAsCollectionItems from '@/components/fSelectResourcesAsCollectionItems';
import FContractHandleDrawer from '@/components/FContractHandleDrawer';
import FAddResourcesHandleAuth from '@/components/FAddResourcesHandleAuth';
import FIcons from '@/components/FIcons';
import FCollectionItems2 from '@/components/FCollectionItems2';
import SortOrderModal from './SortOrderModal';
import FAttrsAndConfigs, { IAttrsAndConfigsItem } from '@/components/FAttrsAndConfigs';
import fResourcePropertyEditor3 from '@/components/fResourcePropertyEditor3';

interface VersionInfoProps extends RouteComponentProps<{ id: string }> {
  dispatch: Dispatch;
  collectionManager: CollectionManagerState;
}

function VersionInfo({ dispatch, collectionManager, match }: VersionInfoProps) {
  const ref_ItemsTitle = React.useRef<any>(null);

  // const [
  //   $handlingCollectionItem,
  //   set$handlingCollectionItem,
  //   get$handlingCollectionItem,
  // ] = FUtil.Hook.useGetState<string>('');

  const [$urlState, set$urlState] = useUrlState<{ version: string }>({
    version: '',
  });
  const [
    $collectionSettingExpansion,
    set$collectionSettingExpansion,
    get$collectionSettingExpansion,
  ] = FUtil.Hook.useGetState<'style' | 'sort' | ''>('');
  const [$logDrawerOpen, set$logDrawerOpen, get$logDrawerOpen] =
    FUtil.Hook.useGetState<boolean>(false);
  // const [$checkedItemIDs, set$checkedItemIDs, get$checkedItemIDs] = FUtil.Hook.useGetState<string[]>([]);

  const [$authProcessorShow, set$authProcessorShow, get$authProcessorShow] =
    FUtil.Hook.useGetState<number>(0);
  const [$licensorId, set$licensorId, get$licensorId] = FUtil.Hook.useGetState<string>('');
  const [$itemId, set$itemId, get$itemId] = FUtil.Hook.useGetState<string>('');

  const [$resourceIDs, set$resourceIDs, get$resourceIDs] = FUtil.Hook.useGetState<string[]>([]);

  const [$sortOrderModalShow, set$sortOrderModalShow, get$sortOrderModalShow] =
    FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(async () => {
    dispatch<Sider_OnMount_Page_Action>({
      type: 'collectionManager/sider_onMount_Page',
      payload: {
        resourceID: match.params.id,
      },
    });

    dispatch<Sider_OnChange_Page_Action>({
      type: 'collectionManager/sider_onChange_Page',
      payload: {
        page: 'versionInfo',
      },
    });
    dispatch<Version_OnMount_Page_Action>({
      type: 'collectionManager/version_onMount_Page',
      payload: {
        resourceID: match.params.id,
        version: $urlState.version,
      },
    });
  });

  AHooks.useUnmount(() => {
    dispatch<Version_OnUnmount_Page_Action>({
      type: 'collectionManager/version_onUnmount_Page',
    });
  });

  const { run: keywordsRun } = AHooks.useDebounceFn(
    () => {
      // console.log('useDebounceEffect ))))))))))))))soifjlskdjlfk');
      dispatch<Version_Fetch_CollectionItems_Action>({
        type: 'collectionManager/version_Fetch_CollectionItems',
      });
    },
    {
      wait: 300,
    },
  );

  const { run: run_saveDraft } = AHooks.useDebounceFn(
    () => {
      dispatch<Version_SaveDraft_Action>({
        type: 'collectionManager/version_SaveDraft',
      });
    },
    {
      wait: 300,
    },
  );

  async function onChange_needSaveDraft(payload: Partial<CollectionManagerState>) {
    await dispatch<ChangeAction>({
      type: 'collectionManager/change',
      payload: {
        ...payload,
        version_otherChanged: true,
      },
    });
    run_saveDraft();
  }

  async function onChange_needSaveDraft_collectionItems(payload: Partial<CollectionManagerState>) {
    await dispatch<ChangeAction>({
      type: 'collectionManager/change',
      payload: {
        ...payload,
        version_collectionItemsChanged: true,
      },
    });
    run_saveDraft();
  }

  async function onChangePage(page: number, pageSize: number) {
    const version_resources_pageCurrent = collectionManager.version_resources_pageCurrent;
    await dispatch<ChangeAction>({
      type: 'collectionManager/change',
      payload: {
        version_resources_pageCurrent: page,
        version_resources_pageSize: pageSize,
      },
    });
    await dispatch<Version_Fetch_CollectionItems_Action>({
      type: 'collectionManager/version_Fetch_CollectionItems',
    });
    if (page !== version_resources_pageCurrent) {
      ref_ItemsTitle.current?.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }

  return (
    <>
      {collectionManager.version_pageState === 'loading' && (
        <div>
          <div style={{ height: 40 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={860} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 20 }}>
            <FSkeletonNode width={200} height={150} />
            <FSkeletonNode width={460} height={40} />
          </div>
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
        </div>
      )}

      <div
        style={{
          display: collectionManager.version_pageState === 'loaded' ? 'block' : 'none',
        }}
      >
        <div style={{ height: 40 }} />

        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <FComponentsLib.FTitleText
              type={'h3'}
              // text={`${collectionManager.version_resourceInfo?.itemsTotalCount || 0}个单品`}
              text={FI18n.i18nNext.t('edit_collection_itemmgnt_itemcount', {
                itemCount: collectionManager.version_resourceInfo?.itemsTotalCount || 0,
              })}
            />
            <FComponentsLib.FTitleText type={'h3'} text={'|'} style={{ color: '#979797' }} />
            {collectionManager.version_resourceInfo?.isFinish && (
              <FComponentsLib.FTitleText
                type={'h3'}
                // text={'已完结'}
                text={FI18n.i18nNext.t('cqr_itemmgmt_updatedstates_completed')}
                style={{ color: '#E9A923' }}
              />
            )}
            {!collectionManager.version_resourceInfo?.isFinish && (
              <FComponentsLib.FTitleText
                type={'h3'}
                // text={'连载中'}
                text={FI18n.i18nNext.t('cqr_itemmgmt_updatestates_ongoing')}
                style={{ color: '#42C28C' }}
              />
            )}
          </div>
          <div style={{ height: 20 }} />

          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            {collectionManager.version_resourceInfo?.isAutomatic && (
              <FComponentsLib.FContentText
                type={'additional2'}
                text={FI18n.i18nNext.t('edit_collection_label_autoadd_defined')}
              />
            )}

            {/*<div style={{ width: 20 }} />*/}
            <FComponentsLib.FContentText
              type={'additional2'}
              // text={`最近更新时间 ${collectionManager.version_resourceInfo?.updateDate || ''}`}
              text={FI18n.i18nNext.t('edit_collection_itemmgnt_lastupdated', {
                Timestamp: collectionManager.version_resourceInfo?.updateDate || '',
              })}
            />
            <FComponentsLib.FTextBtn
              type={'primary'}
              style={{ fontSize: 12 }}
              onClick={() => {
                set$logDrawerOpen(true);
              }}
            >
              {/*查看更新日志*/}
              {FI18n.i18nNext.t('edit_collection_itemmgnt_btn_viewchangelogs')}
            </FComponentsLib.FTextBtn>
          </div>
          <div style={{ height: 40 }} />

          <div className={styles.block}>
            <div ref={ref_ItemsTitle} />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <FComponentsLib.FContentText
                // text={'单品资源管理'}
                text={FI18n.i18nNext.t('cqr_itemmgmt')}
                type={'highlight'}
              />
              {collectionManager.version_collectionItems.length > 0 && (
                <FComponentsLib.FTextBtn
                  style={{
                    fontSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5,
                  }}
                  type='primary'
                  onClick={async () => {
                    const result: string[] | null = await fSelectResourcesAsCollectionItems({
                      collectionID: collectionManager.version_resourceID,
                    });
                    if (!result || result.length === 0) {
                      return;
                    }

                    set$resourceIDs(result);
                  }}
                >
                  <FIcons.FAdd style={{ fontSize: 14 }} />
                  {/*<span>添加单品资源</span>*/}
                  <span>{FI18n.i18nNext.t('cqr_itemmgmt_btn_additem')}</span>
                </FComponentsLib.FTextBtn>
              )}
            </div>

            {collectionManager.version_resources_state !== 'noData' && (
              <>
                <div style={{ height: 20 }} />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                    <FComponentsLib.FContentText
                      // text={`单品数量 ${collectionManager.version_resources_totalCount}`}
                      text={FI18n.i18nNext.t('cqr_itemmgmt_lable_itemqty', {
                        itemCount: collectionManager.version_resources_totalCount,
                      })}
                      type={'additional2'}
                      style={{ color: '#222' }}
                    />
                    <div style={{ position: 'relative' }}>
                      <FComponentsLib.FTextBtn
                        type={'primary'}
                        style={{ fontSize: 12 }}
                        onClick={() => {
                          set$collectionSettingExpansion(
                            get$collectionSettingExpansion() === 'style' ? '' : 'style',
                          );
                        }}
                      >
                        展示样式设置
                        {/*{FI18n.i18nNext.t('cqr_itemmgmt_viewoptions')}*/}
                      </FComponentsLib.FTextBtn>
                      {$collectionSettingExpansion === 'style' && (
                        <div
                          style={{
                            position: 'absolute',
                            top: 35,
                            left: '50%',
                            marginLeft: -15,
                            width: 0,
                            height: 0,
                            borderLeft: '15px solid transparent',
                            borderRight: '15px solid transparent',
                            // borderBottom: '15px solid rgba(0, 0, 0, .03)',
                            borderBottom: '15px solid #F7F7F7',
                          }}
                        />
                      )}
                    </div>
                    <div style={{ position: 'relative' }}>
                      <FComponentsLib.FTextBtn
                        type={'primary'}
                        style={{ fontSize: 12 }}
                        onClick={() => {
                          // set$collectionSettingExpansion(get$collectionSettingExpansion() === 'sort' ? '' : 'sort');
                          set$sortOrderModalShow(true);
                        }}
                      >
                        调整排序
                      </FComponentsLib.FTextBtn>
                    </div>
                  </div>

                  <FComponentsLib.FInput.FSearch
                    value={collectionManager.version_resourceKeywords}
                    onChange={(value) => {
                      dispatch<ChangeAction>({
                        type: 'collectionManager/change',
                        payload: {
                          version_resourceKeywords: value,
                        },
                      });

                      keywordsRun();
                    }}
                    placeholder={FI18n.i18nNext.t('cqr_itemmgmt_search_hint')}
                  />
                </div>
                <div style={{ height: 10 }} />
                {$collectionSettingExpansion === 'style' && (
                  <>
                    <div style={{ height: 10 }} />
                    <CollectionSetting
                      onClose={() => {
                        set$collectionSettingExpansion('');
                      }}
                      setting={collectionManager.version_collectionItemsSetting}
                      onChange={async (value) => {
                        await onChange_needSaveDraft({
                          version_collectionItemsSetting: value,
                        });
                      }}
                      onChangeSort={async (sort) => {
                        await dispatch<Version_Fetch_CollectionItems_Action>({
                          type: 'collectionManager/version_Fetch_CollectionItems',
                        });
                      }}
                      onChangeView={async (view) => {
                        await dispatch<ChangeAction>({
                          type: 'collectionManager/change',
                          payload: {
                            version_resources_pageCurrent: 1,
                            version_resources_pageSize: view === 'collection_view_card' ? 6 : 10,
                          },
                        });
                        await dispatch<Version_Fetch_CollectionItems_Action>({
                          type: 'collectionManager/version_Fetch_CollectionItems',
                        });
                      }}
                    />
                  </>
                )}

                <div style={{ height: 10 }} />
                {collectionManager.version_resources_state === 'noSearchResult' && (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <FComponentsLib.FContentText text={'暂无搜索结果'} type={'additional2'} />
                  </div>
                )}

                {collectionManager.version_resources_state === 'loading' && (
                  <FLoadingTip height={200} />
                )}

                {collectionManager.version_resources_state === 'loaded' && (
                  <FCollectionItems2
                    draggable={$collectionSettingExpansion === 'sort'}
                    showView={
                      collectionManager.version_collectionItemsSetting.collection_view ===
                      'collection_view_list'
                        ? 'list'
                        : 'card'
                    }
                    showCheckbox={$collectionSettingExpansion === 'sort' ? 'show' : 'hide'}
                    // checkedItemIDs={$checkedItemIDs}
                    showCover={
                      $collectionSettingExpansion === 'sort'
                        ? 'show'
                        : collectionManager.version_collectionItemsSetting
                            .collection_item_image_display === 'collection_item_image_display_show'
                        ? 'show'
                        : 'hide'
                    }
                    showNumber={
                      $collectionSettingExpansion === 'sort'
                        ? 'show'
                        : collectionManager.version_collectionItemsSetting
                            .collection_item_no_display === 'collection_item_no_display_show'
                        ? 'show'
                        : 'hide'
                    }
                    showTitle={
                      $collectionSettingExpansion === 'sort'
                        ? 'title'
                        : collectionManager.version_collectionItemsSetting.collection_item_title ===
                          'collection_item_title_rtitle'
                        ? 'title'
                        : collectionManager.version_collectionItemsSetting.collection_item_title ===
                          'collection_item_title_sn'
                        ? 'serial'
                        : collectionManager.version_collectionItemsSetting.collection_item_title ===
                          'collection_item_title_custom'
                        ? 'custom'
                        : 'hide'
                    }
                    showIntroduction={
                      $collectionSettingExpansion === 'sort'
                        ? 'hide'
                        : collectionManager.version_collectionItemsSetting
                            .collection_item_descr_display === 'collection_item_descr_display_show'
                        ? 'show'
                        : 'hide'
                    }
                    resources={collectionManager.version_collectionItems}
                    onClick={(itemID, resourceID) => {
                      // console.log(
                      //   itemID,
                      //   resourceID,
                      //   'itemID, resourceID )))))))))))))))))))))))))))))))',
                      // );
                      // set$handlingCollectionItem(itemID);
                      set$authProcessorShow(get$authProcessorShow() + 1);
                      set$licensorId(resourceID);
                      set$itemId(itemID);
                    }}
                    onChangeCustomTitle={async (itemID, title) => {
                      await FServiceAPI.Resource.updateCollectionItemsInfo_Draft({
                        resourceId: collectionManager.version_resourceID,
                        data: [
                          {
                            itemId: itemID,
                            itemTitle: title,
                          },
                        ],
                      });
                      await onChange_needSaveDraft_collectionItems({});
                      await dispatch<ChangeAction>({
                        type: 'collectionManager/change',
                        payload: {
                          version_collectionItems: collectionManager.version_collectionItems.map(
                            (vc) => {
                              if (vc.itemID !== itemID) {
                                return vc;
                              }
                              return {
                                ...vc,
                                itemTitle: title,
                              };
                            },
                          ),
                        },
                      });
                    }}
                    onClickDelete={async (itemID) => {
                      const { data } = await FServiceAPI.Resource.deleteCollectionItems_Draft({
                        resourceId: collectionManager.version_resourceID,
                        removeCollectionItemIds: [itemID],
                      });
                      await dispatch<ChangeAction>({
                        type: 'collectionManager/change',
                        payload: {
                          version_resources_pageCurrent: Math.min(
                            Math.floor(
                              (collectionManager.version_resources_totalCount - 1) /
                                collectionManager.version_resources_pageSize,
                            ) + 1,
                            collectionManager.version_resources_pageCurrent,
                          ),
                        },
                      });
                      await dispatch<Version_Fetch_CollectionItems_Action>({
                        type: 'collectionManager/version_Fetch_CollectionItems',
                      });
                      await onChange_needSaveDraft_collectionItems({});
                      if (collectionManager.version_resourceInfo) {
                        const {
                          data: data_collectionItems,
                        }: {
                          ret: number;
                          errCode: number;
                          data: {
                            skip: number;
                            limit: number;
                            totalItem: number;
                            dataList: [];
                          };
                        } = await FServiceAPI.Resource.getCollectionItems_Draft({
                          resourceId: collectionManager.version_resourceID,
                          limit: 1,
                        });

                        dispatch<ChangeAction>({
                          type: 'collectionManager/change',
                          payload: {
                            version_resourceInfo: {
                              ...collectionManager.version_resourceInfo,
                              itemsTotalCount: data_collectionItems.totalItem,
                            },
                          },
                        });
                      }
                    }}
                    onChangeIndex={async (id, index, newList) => {
                      const { ret, errCode, msg, data } =
                        await FServiceAPI.Resource.setCollectionItemsSortID_Draft({
                          resourceId: collectionManager.version_resourceID,
                          data: {
                            // @ts-ignore
                            itemIds: [id],
                            targetSortId:
                              collectionManager.version_collectionItemsSetting
                                ?.collection_sort_list === 'collection_sort_ascending'
                                ? (collectionManager.version_resources_pageCurrent - 1) *
                                    collectionManager.version_resources_pageSize +
                                  index +
                                  1
                                : collectionManager.version_resources_totalCount -
                                  (collectionManager.version_resources_pageCurrent - 1) *
                                    collectionManager.version_resources_pageSize -
                                  index,
                          },
                        });

                      if (ret !== 0 || errCode !== 0) {
                        fMessage(msg, 'error');
                        return;
                      }

                      await dispatch<Version_Fetch_CollectionItems_Action>({
                        type: 'collectionManager/version_Fetch_CollectionItems',
                      });
                      await onChange_needSaveDraft_collectionItems({});
                    }}
                  />
                )}

                {((collectionManager.version_collectionItemsSetting.collection_view ===
                  'collection_view_list' &&
                  collectionManager.version_resources_totalCount > 10) ||
                  (collectionManager.version_collectionItemsSetting.collection_view ===
                    'collection_view_card' &&
                    collectionManager.version_resources_totalCount > 6)) && (
                  <>
                    <div style={{ height: 20 }} />

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <Pagination
                        showTitle={false}
                        locale={{
                          // items_per_page: '条/页',
                          items_per_page: FI18n.i18nNext.t('cqr_itemmgmt_list_pagenation_perpage'),
                          // jump_to: '前往',
                          jump_to: FI18n.i18nNext.t('cqr_itemmgmt_list_pagenation_currentpage'),
                          // page: '页',
                          page: ' ',
                        }}
                        size='small'
                        showSizeChanger
                        showQuickJumper
                        current={collectionManager.version_resources_pageCurrent}
                        pageSize={collectionManager.version_resources_pageSize}
                        total={collectionManager.version_resources_totalCount}
                        onChange={onChangePage}
                        showTotal={(total) => {
                          // return `共${total}条`;
                          return FI18n.i18nNext.t('cqr_itemmgmt_list_pagenation_total', {
                            PageCount: total,
                          });
                        }}
                        pageSizeOptions={
                          collectionManager.version_collectionItemsSetting.collection_view ===
                          'collection_view_card'
                            ? [6, 12, 18, 24, 30]
                            : [10, 20, 30, 40, 50]
                        }
                      />
                    </div>
                  </>
                )}
              </>
            )}

            {collectionManager.version_resources_state === 'noData' && (
              <>
                <div style={{ height: 10 }} />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                  }}
                >
                  {/*<span>{FI18n.i18nNext.t('resourceoptions_list_empty')}</span>*/}
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('cqr_itemmgmt_empty_msg')}
                    type={'additional2'}
                  />
                  <div style={{ height: 20 }} />
                  <FComponentsLib.FRectBtn
                    onClick={async () => {
                      const result: string[] | null = await fSelectResourcesAsCollectionItems({
                        collectionID: collectionManager.version_resourceID,
                      });
                      if (!result || result.length === 0) {
                        return;
                      }

                      set$resourceIDs(result);
                    }}
                  >
                    {/*添加单品资源*/}
                    {FI18n.i18nNext.t('cqr_itemmgmt_empty_btn_additem')}
                  </FComponentsLib.FRectBtn>
                </div>
                <div style={{ height: 20 }} />
              </>
            )}
          </div>

          <div style={{ height: 5 }} />

          <div className={styles.block}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <FComponentsLib.FContentText
                text={FI18n.i18nNext.t('resourceinfo_title')}
                type={'highlight'}
              />
              {collectionManager.version_customProperties.length < 30 && (
                <FTooltip title={FI18n.i18nNext.t('resourceinfo_add_btn_info')}>
                  <div>
                    <FComponentsLib.FTextBtn
                      style={{
                        fontSize: 12,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 5,
                      }}
                      type='primary'
                      onClick={async () => {
                        const dataSource: {
                          key: string;
                          name: string;
                          // value: string;
                          description: string;
                        } | null = await fResourcePropertyEditor3({
                          disabledKeys: [
                            ...collectionManager.version_systemProperties.map<string>(
                              (rp) => rp.key,
                            ),
                            ...collectionManager.version_customProperties.map<string>(
                              (bp) => bp.key,
                            ),
                            ...collectionManager.version_customConfigurations.map<string>(
                              (pp) => pp.key,
                            ),
                          ],
                          disabledNames: [
                            ...collectionManager.version_systemProperties.map<string>(
                              (sp) => sp.name,
                            ),
                            ...collectionManager.version_customProperties.map<string>(
                              (bp) => bp.name,
                            ),
                            ...collectionManager.version_customConfigurations.map<string>(
                              (pp) => pp.name,
                            ),
                          ],
                        });
                        // console.log(dataSource, 'dataSource9iojskldjflksdjflk');
                        if (!dataSource) {
                          return;
                        }

                        const finalDate: CollectionManagerState['version_customProperties'] = [
                          ...collectionManager.version_customProperties,
                          {
                            ...dataSource,
                            value: '',
                          },
                        ];

                        await onChange_needSaveDraft({
                          version_customProperties: finalDate,
                        });
                      }}
                    >
                      <FIcons.FProperty style={{ fontSize: 14 }} />
                      <span>补充属性</span>
                    </FComponentsLib.FTextBtn>
                  </div>
                </FTooltip>
              )}
            </div>

            {collectionManager.version_systemProperties.length === 0 &&
              collectionManager.version_customProperties.length === 0 && (
                <>
                  <div style={{ height: 10 }} />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <FComponentsLib.FContentText
                      text={FI18n.i18nNext.t('resourceinfo_empty_msg')}
                      type={'additional2'}
                      style={{ maxWidth: 600, textAlign: 'center' }}
                    />
                  </div>
                  <div style={{ height: 20 }} />
                </>
              )}

            {!(
              collectionManager.version_systemProperties.length === 0 &&
              collectionManager.version_customProperties.length === 0
            ) && (
              <>
                <div style={{ height: 20 }} />
                <FAttrsAndConfigs
                  dateSource={[
                    ...collectionManager.version_systemProperties.map<IAttrsAndConfigsItem>(
                      (sp) => {
                        return {
                          key: sp.key,
                          value: sp.value,
                          name: sp.name,
                          description: sp.description,
                          configs: {
                            item_Deletable: false,
                            key_Editable: false,
                            name_Editable: false,
                            description_Editable: false,
                            value_Editable: (sp.type === 'additional' && sp.valueConfig) || false,
                          },
                        };
                      },
                    ),
                    ...collectionManager.version_customProperties.map<IAttrsAndConfigsItem>(
                      (cp) => {
                        return {
                          key: cp.key,
                          value: cp.value,
                          name: cp.name,
                          description: cp.description,
                          configs: {
                            item_Deletable: true,
                            key_Editable: true,
                            name_Editable: true,
                            description_Editable: true,
                            value_Editable: {
                              text: {
                                nullable: true,
                                minLength: 0,
                                maxLength: 140,
                              },
                            },
                          },
                        };
                      },
                    ),
                  ]}
                  onChangeItem={async (oldData, newData, index, changedFields) => {
                    if (index < collectionManager.version_systemProperties.length) {
                      const newDateSource = [...collectionManager.version_systemProperties];
                      newDateSource[index] = {
                        key: newData.key,
                        name: newData.name,
                        value: newData.value,
                        description: newData.description,
                        type: collectionManager.version_systemProperties[index].type,
                        valueConfig: collectionManager.version_systemProperties[index].valueConfig,
                      };

                      await onChange_needSaveDraft({
                        version_systemProperties: newDateSource,
                      });
                    } else {
                      const newDateSource = [...collectionManager.version_customProperties];
                      newDateSource[index - collectionManager.version_systemProperties.length] = {
                        key: newData.key,
                        name: newData.name,
                        value: newData.value,
                        description: newData.description,
                      };
                      await onChange_needSaveDraft({
                        version_customProperties: newDateSource,
                      });
                    }
                  }}
                  onDeleteItem={async (value) => {
                    const finalDate: CollectionManagerState['version_customProperties'] =
                      collectionManager.version_customProperties.filter((v, i) => {
                        return v.key !== value.key && v.name !== value.name;
                      });

                    await onChange_needSaveDraft({
                      version_customProperties: finalDate,
                    });
                  }}
                  disabledKeys={[
                    ...collectionManager.version_systemProperties.map<string>((rp) => rp.key),
                    ...collectionManager.version_customProperties.map<string>((cp) => cp.key),
                    ...collectionManager.version_customConfigurations.map<string>((cp) => cp.key),
                  ]}
                  disabledNames={[
                    ...collectionManager.version_systemProperties.map<string>((rp) => rp.name),
                    ...collectionManager.version_customProperties.map<string>((cp) => cp.name),
                    ...collectionManager.version_customConfigurations.map<string>((cp) => cp.name),
                  ]}
                />
              </>
            )}
          </div>

          {collectionManager.version_resourceTypeConfig.isSupportOptionalConfig && (
            <>
              <div style={{ height: 5 }} />
              <div className={styles.block}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('resourceoptions_title')}
                    type={'highlight'}
                  />
                  {collectionManager.version_customConfigurations.length < 30 && (
                    // <FTooltip title={FI18n.i18nNext.t('resourceinfo_add_btn_info')}>
                    <FTooltip title={FI18n.i18nNext.t('info_versionoptions')}>
                      <div>
                        <FComponentsLib.FTextBtn
                          style={{
                            fontSize: 12,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 5,
                          }}
                          type='primary'
                          onClick={async () => {
                            const dataSource: {
                              key: string;
                              name: string;
                              type: 'input' | 'select';
                              input: string;
                              select: string[];
                              description: string;
                            } | null = await fResourceOptionEditor({
                              disabledKeys: [
                                ...collectionManager.version_systemProperties.map<string>(
                                  (sp) => sp.key,
                                ),
                                ...collectionManager.version_customProperties.map<string>(
                                  (bp) => bp.key,
                                ),
                                ...collectionManager.version_customConfigurations.map<string>(
                                  (pp) => pp.key,
                                ),
                              ],
                              disabledNames: [
                                ...collectionManager.version_systemProperties.map<string>(
                                  (sp) => sp.name,
                                ),
                                ...collectionManager.version_customProperties.map<string>(
                                  (bp) => bp.name,
                                ),
                                ...collectionManager.version_customConfigurations.map<string>(
                                  (pp) => pp.name,
                                ),
                              ],
                            });

                            if (!dataSource) {
                              return;
                            }

                            const finalData: CollectionManagerState['version_customConfigurations'] =
                              [...collectionManager.version_customConfigurations, dataSource];

                            await onChange_needSaveDraft({
                              version_customConfigurations: finalData,
                            });
                            // await dispatch<Version_SyncAllPropertiesAction>({
                            //   type: 'collectionManager/version_syncAllProperties',
                            // });
                          }}
                        >
                          <FIcons.FConfiguration style={{ fontSize: 14 }} />
                          <span>{FI18n.i18nNext.t('resourceoptions_add_btn')}</span>
                        </FComponentsLib.FTextBtn>
                      </div>
                    </FTooltip>
                  )}
                </div>

                {collectionManager.version_customConfigurations.length === 0 && (
                  <>
                    <div style={{ height: 10 }} />
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {/*<span>{FI18n.i18nNext.t('resourceoptions_list_empty')}</span>*/}
                      <FComponentsLib.FContentText
                        text={FI18n.i18nNext.t('resourceoptions_list_empty')}
                        type={'additional2'}
                      />
                    </div>
                    <div style={{ height: 20 }} />
                  </>
                )}

                {collectionManager.version_customConfigurations.length > 0 && (
                  <>
                    <div style={{ height: 20 }} />
                    <FResourceOptions
                      theme={'dark'}
                      dataSource={collectionManager.version_customConfigurations}
                      onEdit={async (value) => {
                        const index: number =
                          collectionManager.version_customConfigurations.findIndex((p) => {
                            return p === value;
                          });

                        const dataSource: {
                          key: string;
                          name: string;
                          type: 'input' | 'select';
                          input: string;
                          select: string[];
                          description: string;
                        } | null = await fResourceOptionEditor({
                          disabledKeys: [
                            ...collectionManager.version_systemProperties.map<string>(
                              (sp) => sp.key,
                            ),
                            ...collectionManager.version_customProperties.map<string>(
                              (bp) => bp.key,
                            ),
                            ...collectionManager.version_customConfigurations.map<string>(
                              (pp) => pp.key,
                            ),
                          ],
                          disabledNames: [
                            ...collectionManager.version_systemProperties.map<string>(
                              (sp) => sp.name,
                            ),
                            ...collectionManager.version_customProperties.map<string>(
                              (bp) => bp.name,
                            ),
                            ...collectionManager.version_customConfigurations.map<string>(
                              (pp) => pp.name,
                            ),
                          ],
                          defaultData: value,
                        });

                        if (!dataSource) {
                          return;
                        }

                        const finalData: CollectionCreatorPageModelState['step2_customConfigurations'] =
                          collectionManager.version_customConfigurations.map((a, b) => {
                            if (b !== index) {
                              return a;
                            }
                            return dataSource;
                          });

                        await onChange_needSaveDraft({
                          version_customConfigurations: finalData,
                        });
                        // await dispatch<Version_SyncAllPropertiesAction>({
                        //   type: 'collectionManager/version_syncAllProperties',
                        // });
                      }}
                      onDelete={async (value) => {
                        const finalData: CollectionCreatorPageModelState['step2_customConfigurations'] =
                          collectionManager.version_customConfigurations.filter((a) => {
                            return a.key !== value.key && a.name !== value.name;
                          });
                        await onChange_needSaveDraft({
                          version_customConfigurations: finalData,
                        });
                        // await dispatch<Version_SyncAllPropertiesAction>({
                        //   type: 'collectionManager/version_syncAllProperties',
                        // });
                      }}
                    />
                  </>
                )}
              </div>
            </>
          )}

          {collectionManager.version_reload > 0 && (
            <>
              <div style={{ height: 5 }} />
              <div className={styles.block}>
                {collectionManager.version_reload > 0 && (
                  <FMicroAPP_Authorization
                    // reload={collectionManager.version_reload}
                    licenseeId={collectionManager.version_resourceID}
                    mainAppType={'resourceInVersionUpdate'}
                    // mainAppType={'resourceInfoPool'}
                    depList={collectionManager.version_directDependencies}
                    upcastList={collectionManager.version_baseUpcastResources}
                    mount={(data) => {
                      dispatch<ChangeAction>({
                        type: 'collectionManager/change',
                        payload: {
                          // version_directDependencies: data.depList,
                          version_directDependencies: data.directDependencies || [],
                          // version_resolveResources: data.resolveResources,
                          version_baseUpcastResources: data.baseUpcastResources || [],
                          version_authExcludedItems: data.authExcludedItems || [],
                        },
                      });
                    }}
                    update={async (data) => {
                      await onChange_needSaveDraft({
                        version_directDependencies: data.directDependencies || [],
                        // version_resolveResources: data.resolveResources,
                        version_baseUpcastResources: data.baseUpcastResources || [],
                        version_authExcludedItems: data.authExcludedItems || [],
                      });
                    }}
                  />
                )}
              </div>
            </>
          )}

          <div style={{ height: 5 }} />

          <VersionDescriptionEditor
            value={collectionManager.version_descriptionText}
            onChange={async (value) => {
              await onChange_needSaveDraft({
                version_descriptionText: value,
              });
            }}
          />

          {collectionManager.version_graphShow && (
            <>
              <div style={{ height: 5 }} />
              <div className={styles.block}>
                <FComponentsLib.FContentText text={'相关视图'} type={'highlight'} />
                <div style={{ height: 20 }} />

                <FViewportCards_Resource
                  resourceID={collectionManager.version_resourceID}
                  version={collectionManager.version_version}
                  graphShow={['authorization', 'dependency']}
                  onMount={({ hasData }) => {
                    // console.log(hasData, 'hasDataiosdjflkjsdflkjlk');
                    dispatch<ChangeAction>({
                      type: 'collectionManager/change',
                      payload: {
                        version_graphShow: hasData,
                      },
                    });
                  }}
                />
              </div>
            </>
          )}
        </div>
        <div style={{ height: 100 }} />
      </div>

      {collectionManager.version_resourceID !== '' && $resourceIDs.length === 0 && (
        <FContractHandleDrawer
          open={$authProcessorShow}
          licensorId={$licensorId}
          itemId={$itemId}
          licenseeId={collectionManager.version_resourceID}
          onUpdate={async (options) => {
            // const itemData: {
            //   itemId: string;
            //   authExcludedItems: {
            //     resourceId: string;
            //     excludedType: 'contractId' | 'policyId';
            //     excludedValue: string;
            //   }[];
            // } = {
            //   itemId: get$itemId(),
            //   authExcludedItems: options.authExcludedItems
            //     .map((item) => {
            //       return item.contracts.map((contract) => {
            //         return {
            //           resourceId: item.resourceID,
            //           excludedType: 'contractId' as const,
            //           excludedValue: contract.contractID,
            //         };
            //       });
            //     })
            //     .flat(),
            // };

            // const { ret, errCode, msg, data } = await FServiceAPI.Resource.setItemsTitle({
            //   resourceId: collectionManager.version_resourceID,
            //   data: [itemData],
            // });

            // if (ret !== 0 || errCode !== 0) {
            //   fMessage(msg, 'error');
            //   return;
            // }

            await dispatch<Version_Fetch_CollectionItems_Action>({
              type: 'collectionManager/version_Fetch_CollectionItems',
            });
            await onChange_needSaveDraft_collectionItems({});
          }}
          onClose={() => {
            set$licensorId('');
            set$itemId('');
            set$authProcessorShow(0);
          }}
        />
      )}

      {(collectionManager.version_collectionItemsChanged ||
        collectionManager.version_otherChanged) && (
        <div className={styles.bottomDraft}>
          <div className={styles.bottomDraftContent}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <FIcons.FInfo style={{ fontSize: 12, color: '#999', lineHeight: '18px' }} />
              <FComponentsLib.FContentText
                type={'additional2'}
                text={FI18n.i18nNext.t('edit_collection_itemmgnt_submit_info')}
                style={{ color: '#C4C4C4' }}
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 30 }}>
              {collectionManager.version_draftSaveTime !== '' &&
                !collectionManager.version_draftSaving && (
                  <FComponentsLib.FContentText
                    // text={`已保存 ${collectionManager.version_draftSaveTime}`}
                    text={FI18n.i18nNext.t('edit_collection_itemmgnt_savedraft_state_saved', {
                      LastEditTime: collectionManager.version_draftSaveTime,
                    })}
                    type={'additional2'}
                  />
                )}

              {collectionManager.version_draftSaving && (
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('edit_collection_itemmgnt_savedraft_state_saving')}
                  type={'additional2'}
                />
              )}

              {/*{FI18n.i18nNext.t('rqr_step3_btn_later')}*/}
              <FComponentsLib.FTextBtn
                type={'default'}
                onClick={() => {
                  dispatch<Version_SaveDraft_Action>({
                    type: 'collectionManager/version_SaveDraft',
                    // payload: {
                    //   showSuccessTip: true,
                    // },
                  });
                }}
              >
                {FI18n.i18nNext.t('save_as_draft')}
              </FComponentsLib.FTextBtn>
              {/*{FI18n.i18nNext.t('rqr_step3_btn_next')}*/}
              <FComponentsLib.FRectBtn
                disabled={
                  !(
                    collectionManager.version_collectionItemsChanged ||
                    collectionManager.version_otherChanged
                  )
                }
                type={'primary'}
                onClick={async () => {
                  const result = await dispatch<Version_SaveDate_Action>({
                    type: 'collectionManager/version_SaveDate',
                  });
                  if (!result) {
                    return;
                  }

                  await dispatch<ChangeAction>({
                    type: 'collectionManager/change',
                    payload: {
                      version_collectionItemsChanged: false,
                      version_otherChanged: false,
                    },
                  });

                  run_saveDraft();
                }}
              >
                {FI18n.i18nNext.t('edit_collection_itemmgnt_submit_btn')}
              </FComponentsLib.FRectBtn>
            </div>
          </div>
        </div>
      )}

      <ChangeLogDrawer
        collectionID={collectionManager.version_resourceID}
        open={$logDrawerOpen}
        onClose={() => {
          set$logDrawerOpen(false);
        }}
      />

      {collectionManager.version_resourceID !== '' && $resourceIDs.length > 0 && (
        <FAddResourcesHandleAuth
          resourceIDs={$resourceIDs}
          collectionID={collectionManager.version_resourceID}
          isPublish={false}
          onCancel={() => {
            set$resourceIDs([]);
          }}
          onOk={async () => {
            set$resourceIDs([]);

            await onChange_needSaveDraft_collectionItems({});

            await dispatch<Version_Fetch_CollectionItems_Action>({
              type: 'collectionManager/version_Fetch_CollectionItems',
            });

            if (collectionManager.version_resourceInfo) {
              const {
                data: data_collectionItems,
              }: {
                ret: number;
                errCode: number;
                data: {
                  skip: number;
                  limit: number;
                  totalItem: number;
                  dataList: [];
                };
              } = await FServiceAPI.Resource.getCollectionItems_Draft({
                resourceId: collectionManager.version_resourceID,
                limit: 1,
              });

              dispatch<ChangeAction>({
                type: 'collectionManager/change',
                payload: {
                  version_resourceInfo: {
                    ...collectionManager.version_resourceInfo,
                    itemsTotalCount: data_collectionItems.totalItem,
                  },
                },
              });
            }
          }}
          onBack={async () => {
            set$resourceIDs([]);

            const result: string[] | null = await fSelectResourcesAsCollectionItems({
              collectionID: collectionManager.version_resourceID,
            });
            if (!result || result.length === 0) {
              return;
            }

            set$resourceIDs(result);
          }}
          onError={() => {
            set$resourceIDs([]);
          }}
        />
      )}

      <SortOrderModal
        setting={collectionManager.version_collectionItemsSetting}
        open={$sortOrderModalShow}
        collectionItems={collectionManager.version_collectionItems}
        onChangeSetting={async (value) => {
          await onChange_needSaveDraft({
            version_collectionItemsSetting: value,
          });
        }}
        onChangeSortSetting={async (sort) => {
          await dispatch<Version_Fetch_CollectionItems_Action>({
            type: 'collectionManager/version_Fetch_CollectionItems',
          });
        }}
        onClickSortBy={async (sort: 'added' | 'title' | 'updateDate') => {
          const { ret, errCode, msg, data } =
            await FServiceAPI.Resource.reorderCollectionItems_Draft({
              resourceId: collectionManager.version_resourceID,
              sortField:
                sort === 'added'
                  ? 'createDate'
                  : sort === 'title'
                  ? 'itemTitle'
                  : 'resourceUpdateDate',
              sortType: sort === 'added' ? -1 : sort === 'title' ? 1 : -1,
            });

          if (ret !== 0 || errCode !== 0) {
            fMessage(msg, 'error');
            return;
          }
          await dispatch<Version_Fetch_CollectionItems_Action>({
            type: 'collectionManager/version_Fetch_CollectionItems',
          });
        }}
        onChangeItemsSortID={async (itemIDs: string[], sortID: number) => {
          const { ret, errCode, msg, data } =
            await FServiceAPI.Resource.setCollectionItemsSortID_Draft({
              resourceId: collectionManager.version_resourceID,
              data: {
                itemIds: itemIDs,
                targetSortId: sortID,
              },
            });

          if (ret !== 0 || errCode !== 0) {
            fMessage(msg, 'error');
            return;
          }
          // set$checkedItemIDs([]);

          await dispatch<Version_Fetch_CollectionItems_Action>({
            type: 'collectionManager/version_Fetch_CollectionItems',
          });
          await onChange_needSaveDraft_collectionItems({});
        }}
        pageSize={collectionManager.version_resources_pageSize}
        pageCurrent={collectionManager.version_resources_pageCurrent}
        totalCount={collectionManager.version_resources_totalCount}
        onChangePage={onChangePage}
        onCancel={() => {
          set$sortOrderModalShow(false);
        }}
      />
    </>
  );
}

export default withRouter(
  connect(({ collectionManager }: ConnectState) => ({
    collectionManager: collectionManager,
  }))(VersionInfo),
);

interface VersionDescriptionEditorBlock {
  value: string;

  onChange?(value: string): void;
}

export function VersionDescriptionEditor({ value, onChange }: VersionDescriptionEditorBlock) {
  const [$value, set$value, get$value] = FUtil.Hook.useGetState<string>(value);
  const [$isEditing, set$isEditing] = FUtil.Hook.useGetState<boolean>(false);
  const [$editor, set$editor] = FUtil.Hook.useGetState<EditorState>(
    BraftEditor.createEditorState(value),
  );

  AHooks.useDebounceEffect(
    () => {
      if (get$value() !== value) {
        set$value(value);
        set$editor(BraftEditor.createEditorState(value));
      }
    },
    [value],
    {
      wait: 100,
    },
  );

  return (
    <div className={styles.block}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.t('edit_collection_itemmgnt_descr')}
          type={'highlight'}
        />

        <Space size={10}>
          {$isEditing && (
            <>
              {/*<FComponentsLib.FTextBtn*/}
              {/*  type='default'*/}
              {/*  onClick={() => {*/}
              {/*    onChange({ descriptionFullScreen: true });*/}
              {/*  }}*/}
              {/*>全屏编辑</FComponentsLib.FTextBtn>*/}
              {/*<FDivider />*/}
              <FComponentsLib.FTextBtn
                type='default'
                onClick={() => {
                  set$isEditing(false);
                }}
              >
                {FI18n.i18nNext.t('cancel')}
              </FComponentsLib.FTextBtn>
              <FComponentsLib.FTextBtn
                type='primary'
                onClick={async () => {
                  const html: string = $editor.toHTML();
                  const description: string = html === '<p></p>' ? '' : html;
                  set$value(description);
                  onChange && onChange(description);
                  set$isEditing(false);
                }}
              >
                {FI18n.i18nNext.t('save')}
              </FComponentsLib.FTextBtn>
            </>
          )}
          {!$isEditing && value !== '' && (
            <>
              <FComponentsLib.FTextBtn
                type='primary'
                onClick={() => {
                  set$isEditing(true);
                }}
              >
                编辑
              </FComponentsLib.FTextBtn>
            </>
          )}
        </Space>
      </div>

      {value === '' && !$isEditing && (
        <>
          <div style={{ height: 10 }} />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <FComponentsLib.FContentText
              // text={'动动手，让你的资源看起来更丰富～'}
              // text={FI18n.i18nNext.t('edit_collection_itemmgnt_descr_empty_info')}
              text={FI18n.i18nNext.t('version_description_empty_msg')}
              type={'additional2'}
            />
            <div style={{ height: 20 }} />

            <FComponentsLib.FRectBtn
              type={'primary'}
              onClick={() => {
                set$isEditing(true);
              }}
            >
              {/*添加版本描述*/}
              {/*{FI18n.i18nNext.t('edit_collection_itemmgnt_descr_empty_btn')}*/}
              {FI18n.i18nNext.t('version_description_empty_btn')}
            </FComponentsLib.FRectBtn>
          </div>
        </>
      )}

      {$isEditing && (
        <>
          <div style={{ height: 20 }} />

          <FBraftEditor
            value={$editor}
            // defaultValue={editorText}
            onChange={(value: EditorState) => {
              set$editor(value);
            }}
            style={{ minHeight: 500 }}
          />
        </>
      )}

      {!$isEditing && value && (
        <>
          <div style={{ height: 20 }} />
          <div className={styles.description}>
            <FHtmlReactParser str={value} />
          </div>
        </>
      )}
    </div>
  );
}
